import Enums from 'utils/EnumsManager';

const { REPORT } = Enums.REDUX_ACTION_TYPE_PREFIX;
export const SET_AVAILABLE_COLUMNS = `${REPORT}_SET_AVAILABLE_COLUMNS`;
export const SET_ZONES = `${REPORT}_SET_ZONES`;
export const RESET_SELECTEDCOLS = `${REPORT}_RESET_SELECTEDCOLS`;



// WEBPACK FOOTER //
// ./src/views/ReportSetup/flow/actionTypes.js